import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import payments from "./paymentsReducer";
import domiciliationReducer from "./domiciliationReducer";
import favoritesRefReducer from "./favoritesRefReducer";
import payReminderReducer from "./payReminderReducer";
import messagingReducer from "./messaging";
import aploanReducer from "./aploan";

export default combineReducers({
  payments,
  domiciliationReducer,
  favoritesRefReducer,
  payReminderReducer,
  messagingReducer,
  messagingReducer,
  aploanReducer,
  router: routerReducer,
});
